import React from "react";
import $ from 'jquery';
import moment from "moment";

import * as Misc from "./../../../misc";
import ActionTypes from "./../../../actionTypes";
import ProjectScope from "./../../projectScope/projectScope";

import Analytics from './../../../analytics';

export default class NotesItemView extends React.Component {
  constructor(props) {
    super(props);

    const thisNote = this.props.note;
    const note = ProjectScope.currentNote();
    let selected = false;
    let disabled = false;
    if (note) {
      if (thisNote.uid === note.uid) {
        selected = true;
      } else {
        if (note.changed) {
          disabled = true;
        }
      }
    }

    this.state = {
      selected: selected,
      disabled: disabled
    };
  }

  componentDidMount() {
    $(document).on(ActionTypes.CURRENT_NOTE_CHANGED, this.handleNoteChanged);
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.CURRENT_NOTE_CHANGED, this.handleNoteChanged);
  }

  handleNoteChanged = (e, data) => {
    const thisNote = this.props.note;
    const note = ProjectScope.currentNote();

    let selected = false;
    let disabled = false;

    if (note) {
      if (thisNote.uid === note.uid) {
        selected = true;
      } else {
        if (note.changed) {
          disabled = true;
        }
      }
    }

    this.setState({
      selected: selected,
      disabled: disabled
    });
  };

  handleClick = (e) => {
    Misc.ignoreDefault(e);
    Analytics.sendClickEvent('summary-note-select');
    if (this.state.disabled || this.state.selected) {
      return;
    }

    ProjectScope.selectNote(this.props.note);
  };

  handleRemoveClick = (e) => {
    Misc.ignoreDefault(e);
    Analytics.sendClickEvent('summary-note-delete');
    ProjectScope.deleteNote(this.props.note);
  };

  handleAddNoteClick = (e) => {
    Misc.ignoreDefault(e);
    if (this.state.disabled) {
      Analytics.sendClickEvent('summary-note-add-disabled');
      return;
    }
    Analytics.sendClickEvent('summary-note-add');

    ProjectScope.addNote();
  };

  render() {
    const note = this.props.note;
    let removeButtonElement = null;

    if (note.addNew) {
      return (<div className={"doc-note-item-add-note" + (this.state.disabled ? ' doc-note-item-disabled' : '') }
                   onClick={this.handleAddNoteClick}>
        Add New Note</div>);
    }

    let className = "doc-note-item";
    if (this.state.selected) {
      className += " doc-note-item-selected";
      if (!note.isNew && !ProjectScope.jobId) {
        removeButtonElement = (
          <div className="project-scope-selection-remove-button" onClick={this.handleRemoveClick}/>);
      }
    } else if (this.state.disabled) {
      className += ' doc-note-item-disabled';
    }

    return (
      <div className={className}
           onClick={this.handleClick}>{moment(note.title).format("MM-DD-YY [at] hh:mm")}{removeButtonElement}</div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/common/notesUpload/noteItem.js